/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_BadgeInputs */

const et_plan_visibility_badge = /** @type {(inputs: Plan_Visibility_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enim valitud`)
};

const en_plan_visibility_badge = /** @type {(inputs: Plan_Visibility_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most chosen`)
};

/**
* | output |
* | --- |
* | "Most chosen" |
*
* @param {Plan_Visibility_BadgeInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_badge = /** @type {((inputs?: Plan_Visibility_BadgeInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_BadgeInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_badge(inputs)
	return en_plan_visibility_badge(inputs)
});